const API_URL =
  // @ts-ignore TODO: fix type for API
  (import.meta.env && import.meta.env.VITE_API_URL) || 'http://localhost:3002';

export default {
  url: API_URL,
  endpoints: {
    pageLayout: `${API_URL}/pages/layout`,
    pages: `${API_URL}/pages`,
    competitions: `${API_URL}/competitions`,
    leagueTable: `${API_URL}/competitions/league-table`,
    leagueOptions: `${API_URL}/competitions/league-options`,
    match: `${API_URL}/matches`,
    matches: `${API_URL}/matches`,
    matchDates: `${API_URL}/matches/match-dates`,
    articles: `${API_URL}/articles`,
    faqs: `${API_URL}/faqs`,
    tags: `${API_URL}/tags`,
    featuredTags: `${API_URL}/tags/featured`,
    clubs: `${API_URL}/clubs`,
    editableClubs: `${API_URL}/clubs/list-editable`,
    teams: `${API_URL}/teams`,
    teamsSearch: `${API_URL}/teams/search`,
    assets: `${API_URL}/assets`,
    upload: `${API_URL}/assets/upload`,
    login: `${API_URL}/auth/login`,
    myProfile: `${API_URL}/users/me`,
    users: `${API_URL}/users`,
    sponsors: `${API_URL}/sponsors`,
    mainSponsor: `${API_URL}/sponsors/main`,
    navigations: `${API_URL}/navigations`,
    newsletterSubscribe: `${API_URL}/mails/newsletter-subscribe`,
    newsletterConfirm: `${API_URL}/mails/newsletter-confirm`,
    jobs: `${API_URL}/jobs`,
    socialNetworks: `${API_URL}/social-networks`,
    contacts: `${API_URL}/contacts`,
    settings: `${API_URL}/settings`,
    matchSettings: `${API_URL}/settings/match`,
    articleSettings: `${API_URL}/settings/article`,
    matchFilters: `${API_URL}/settings/match-filters`,
    tenants: `${API_URL}/tenants`,
    tenantsFeatureFlags: `${API_URL}/tenants/feature-flags`,
    contactUs: `${API_URL}/mails/contact-us`,
    liveFeed: `${API_URL}/live-feed`,
  },
};
